import { useEffect, useState } from "react";
import { API, type SAVSummary } from "../api";

function badgeClass(status: string): string {
  if (status.startsWith("CLOS_")) return "xs-badge xs-badge-gray";
  if (status.includes("DIAGNOSTIC")) return "xs-badge xs-badge-yellow";
  if (status.includes("INTER_TECH") || status.includes("ATELIER"))
    return "xs-badge xs-badge-blue";
  return "xs-badge xs-badge-green";
}

export function HomeView({
  onDeclare,
  onOpen,
}: {
  onDeclare: () => void;
  onOpen: (id: string) => void;
}) {
  const [inProgress, setInProgress] = useState<SAVSummary[]>([]);
  const [closed, setClosed] = useState<SAVSummary[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    API.listSAVs().then((r) => {
      setInProgress(r.in_progress);
      setClosed(r.closed);
      setLoading(false);
    });
  }, []);

  return (
    <div>
      <div
        className="xs-row-between"
        style={{ marginBottom: 16, alignItems: "flex-end" }}
      >
        <div>
          <h2 style={{ margin: 0, fontSize: 20 }}>Vos dossiers SAV</h2>
          <p className="xs-muted" style={{ margin: "4px 0 0" }}>
            Propulsé par Xsavier
          </p>
        </div>
        <button className="xs-btn xs-btn-primary" onClick={onDeclare}>
          + Déclarer un SAV
        </button>
      </div>

      {loading && <div className="xs-muted">Chargement…</div>}

      {!loading && (
        <>
          <div style={{ marginBottom: 20 }}>
            <div
              className="xs-muted"
              style={{
                textTransform: "uppercase",
                letterSpacing: 0.5,
                fontSize: 11,
                marginBottom: 8,
              }}
            >
              En cours ({inProgress.length})
            </div>
            {inProgress.length === 0 ? (
              <div className="xs-card" style={{ textAlign: "center", color: "#64748b" }}>
                Aucun dossier en cours.
              </div>
            ) : (
              <div className="xs-list">
                {inProgress.map((s) => (
                  <button
                    key={s.id}
                    className="xs-tile"
                    onClick={() => onOpen(s.id)}
                  >
                    <div className="xs-tile-row">
                      <div style={{ minWidth: 0 }}>
                        <div className="xs-tile-meta xs-mono">{s.reference}</div>
                        <div className="xs-tile-title xs-truncate">
                          {s.product_name || "Produit"}
                        </div>
                      </div>
                      <span className={badgeClass(s.status)}>{s.status}</span>
                    </div>
                  </button>
                ))}
              </div>
            )}
          </div>

          {closed.length > 0 && (
            <div>
              <div
                className="xs-muted"
                style={{
                  textTransform: "uppercase",
                  letterSpacing: 0.5,
                  fontSize: 11,
                  marginBottom: 8,
                }}
              >
                Clos récents
              </div>
              <div className="xs-list">
                {closed.map((s) => (
                  <button
                    key={s.id}
                    className="xs-tile"
                    onClick={() => onOpen(s.id)}
                    style={{ opacity: 0.75 }}
                  >
                    <div className="xs-tile-row">
                      <div style={{ minWidth: 0 }}>
                        <div className="xs-tile-meta xs-mono">{s.reference}</div>
                        <div className="xs-tile-title xs-truncate">
                          {s.product_name || "Produit"}
                        </div>
                      </div>
                      <span className={badgeClass(s.status)}>{s.status}</span>
                    </div>
                  </button>
                ))}
              </div>
            </div>
          )}
        </>
      )}
    </div>
  );
}
